module.exports = __webpack_public_path__ + "img/PARTNERED_SERVER_OWNER.628fbe24.svg";